import * as React from 'react';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import getServicesObject from '../selectors/getServices';
import getServices from '../orchestration/getServices';
import createService from '../orchestration/createService';
import deleteService from '../orchestration/deleteService';
import BookingService from 'owa-service/lib/contract/BookingService';

const styles = require('./ServicesTest.scss');

export default observer(function ServicesTest() {
    const ServiceNamePrefix: string = 'Meeting Type ';

    const onDeleteService = () => {
        // Delete the first service with the temp name.
        const services = getServicesObject();

        let itemId;
        services.forEach(service => {
            if (service.DisplayName.indexOf(ServiceNamePrefix) == 0) {
                itemId = service.ItemId;
            }
        });

        if (itemId) {
            deleteService(itemId);
        }
    };

    const onCreateService = () => {
        // Create a unique temp name for the new service.
        const name: string = ServiceNamePrefix + (Math.floor(Math.random() * 999) + 100); //3 digit

        const partialService: BookingService = {
            DisplayName: name,
            Description: 'Test service',
            DefaultDurationMinutes: 60,
            DefaultLocation: undefined,
            InternalNotes: 'Test service',
        };

        createService(partialService);
    };

    const onGetServices = () => {
        getServices();
    };

    const services = getServicesObject();
    let serviceNames: string = '';
    services.forEach(value => {
        if (value) {
            serviceNames += ` [${value.DisplayName}:${value.ServiceId}],`;
        }
    });

    return (
        <div>
            <div>
                <div>{'******* Test Control to get, create and delete services *******'}</div>
                <div>&nbsp;</div>
                <div>{`*** Action succeeded: Service count ${
                    services.length
                }, Service names: ${serviceNames} ***`}</div>
                <div>&nbsp;</div>

                <div className={styles.servicesTestSection}>
                    <DefaultButton
                        primary={false}
                        disabled={false}
                        text={'create service'}
                        className={styles.createButton}
                        onClick={onCreateService}
                    />

                    <DefaultButton
                        primary={false}
                        disabled={false}
                        text={'delete service'}
                        className={styles.deleteButton}
                        onClick={onDeleteService}
                    />

                    <DefaultButton
                        primary={false}
                        disabled={false}
                        text={'get services'}
                        className={styles.getButton}
                        onClick={onGetServices}
                    />
                </div>
            </div>
        </div>
    );
});
